import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/soul";
import { useAuth } from "@/context/AuthContext";
import { Flame, X } from "lucide-react";

export default function StreakNudge() {
  const { user } = useAuth();
  const [streak, setStreak] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const todayKey = `streak_nudge_${new Date().toISOString().slice(0, 10)}`;

  useEffect(() => {
    if (!user) return;
    if (localStorage.getItem(todayKey)) {
      setDismissed(true);
      return;
    }
    api.get("/roots/streak").then((r) => setStreak(r.data)).catch(() => {});
  }, [user, todayKey]);

  if (!user || dismissed || !streak || streak.learned_today) return null;

  const hasStreak = streak.streak > 0;

  const close = () => {
    localStorage.setItem(todayKey, "1");
    setDismissed(true);
  };

  return (
    <div data-testid="streak-nudge" className="max-w-7xl mx-auto px-6 pt-6">
      <div className="glass rounded-2xl px-6 py-4 flex items-center gap-4 border-l-2" style={{ borderLeftColor: "#D4AF37" }}>
        <span className="h-10 w-10 rounded-full bg-[#D4AF37]/10 grid place-items-center text-[#D4AF37] shrink-0">
          <Flame size={20} />
        </span>
        <p className="text-[#F5F1E7] text-sm sm:text-base flex-1">
          {hasStreak ? (
            <>Your <span className="text-[#D4AF37] font-medium">{streak.streak}-day</span> root streak is waiting — learn today's root to keep it alive.</>
          ) : (
            <>Begin a daily practice — learn today's Latin or Greek root and start a streak.</>
          )}
        </p>
        <Link
          to="/roots"
          data-testid="streak-nudge-cta"
          className="shrink-0 rounded-full bg-[#D4AF37] text-[#110D14] px-5 py-2 text-sm font-medium hover:bg-[#e6c860] transition-colors duration-300"
        >
          Today's root
        </Link>
        <button data-testid="streak-nudge-close" onClick={close} className="shrink-0 text-[#A8A29E] hover:text-[#F5F1E7] transition-colors duration-300">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
